import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './furnitureobjects.css'; // Import the CSS file for styling

function FurnitureObjects() {
  const images = [
   "/images/Furniture and Objects/Furniture_01.jpg",
  "/images/Furniture and Objects/Furniture_02.jpg",
  "/images/Furniture and Objects/Furniture_03.jpg",
  "/images/Furniture and Objects/Furniture_04.jpg",
  "/images/Furniture and Objects/Furniture_05.jpg",
  "/images/Furniture and Objects/Furniture_06.jpg",
  "/images/Furniture and Objects/Furniture_07.jpg",
  "/images/Furniture and Objects/Furniture_08.jpg",
  "/images/Furniture and Objects/Furniture_09.jpg",
  "/images/Furniture and Objects/Furniture_10.jpg",
  "/images/Furniture and Objects/Furniture_11.jpg",
  "/images/Furniture and Objects/Furniture_12.jpg",
  "/images/Furniture and Objects/Furniture_13.jpg",
  "/images/Furniture and Objects/Furniture_14.jpg",
  "/images/Furniture and Objects/Furniture_15.jpg",
  "/images/Furniture and Objects/Furniture_16.jpg",
  "/images/Furniture and Objects/Furniture_17.jpg",
  "/images/Furniture and Objects/Furniture_18.jpg",
  "/images/Furniture and Objects/Furniture_19.jpg",
  "/images/Furniture and Objects/Furniture_20.jpg",
  "/images/Furniture and Objects/Furniture_21.jpg",
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  // Auto change image every 6 seconds
  useEffect(() => {
    const interval = setInterval(nextImage, 6000);
    return () => clearInterval(interval); // Clean up on component unmount
  }, []);

  return (
    <div className="furnitureobjects-container">
      <Link to="/" className="home-button">Home</Link> {/* Home button */}
      
      <div className="text-container">
        <h2>
          <div className="title-gc">Furniture & Objects</div>
        </h2>
        <p>
          <div className="text-blurb">
            Traditional Line’s restoration team provides expert repair, conservation, and finishing of 
            furniture and decorative objects, including restoration and modification of antique lighting fixtures.
          </div>
        </p>
      </div>

      <div className="image-frame">
        <div className="slideshow-container">
          <img
            src={images[currentImageIndex]}
            alt="Furniture & Objects"
            className="furnitureobjects-image"
          />
          
          <button className="prev-button" onClick={prevImage}>❮</button>
          <button className="next-button" onClick={nextImage}>❯</button>
        </div>
      </div>
    </div>
  );
}

export default FurnitureObjects;
